module.exports = __webpack_public_path__ + "img/10200.e694d0be.jpg";